import imageFragment from "./image";
import seoFragment from "./seo";

const productFragment = /* GraphQL */ `
  fragment product on Product {
    id
    handle
    availableForSale
    title
    description
    options {
      id
      name
      values
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    metafields(
      identifiers: [
        { namespace: "custom", key: "product_aesthetic_media" }
        { namespace: "custom", key: "accessories_extended_info" }
        { namespace: "custom", key: "hero_section_landing_media_desktop" }
        { namespace: "custom", key: "hero_section_landing_media_mobile" }
        { namespace: "custom", key: "exit_section_media_mobile" }
        { namespace: "custom", key: "exit_section_media_desktop" }
        { namespace: "custom", key: "product_assembly_guide_pdf" }
        { namespace: "custom", key: "product_assembly_guide_video" }
        { namespace: "custom", key: "product_usage_guide_manual" }
        { namespace: "custom", key: "product_usage_guide_video" }
        { namespace: "custom", key: "product_popularity_tag" }
        { namespace: "custom", key: "preorder_popup" }
        { namespace: "custom", key: "studio_photos" }
      ]
    ) {
      namespace
      key
      type
      value
      reference {
        __typename
        ... on Metaobject {
          id
          type
          handle
          fields {
            key
            value
            reference {
              __typename
              ... on MediaImage {
                image {
                  url
                }
              }
              ... on Video {
                previewImage {
                  url
                  width
                  height
                }
                sources {
                  url
                  mimeType
                  height
                }
              }
            }
            references(first: 50) {
              edges {
                node {
                  __typename
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                  ... on Video {
                    previewImage {
                      url
                      width
                      height
                    }
                    sources {
                      url
                      mimeType
                      height
                    }
                  }
                }
              }
            }
          }
        }
      }
      references(first: 50) {
        edges {
          node {
            __typename
            ... on MediaImage {
              image {
                ...image
              }
            }
            ... on Video {
              id
              previewImage {
                url
                width
                height
              }
              sources {
                url
                mimeType
                height
              }
            }
            ... on Metaobject {
              id
              type
              handle
              fields {
                key
                value
                reference {
                  __typename
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                  ... on Video {
                    previewImage {
                      url
                      width
                      height
                    }
                    sources {
                      url
                      mimeType
                      height
                    }
                  }
                }
                references(first: 50) {
                  edges {
                    node {
                      __typename
                      ... on MediaImage {
                        image {
                          url
                        }
                      }
                      ... on Video {
                        sources {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    variants(first: 100) {
      edges {
        node {
          id
          title
          sku
          availableForSale
          quantityAvailable
          selectedOptions {
            name
            value
          }
          price {
            amount
            currencyCode
          }
          metafields(
            identifiers: [
              { namespace: "custom", key: "media" }
              { namespace: "custom", key: "primary_color" }
              { namespace: "custom", key: "pre_order" }
              { namespace: "custom", key: "pre_order_delivery_date" }
              { namespace: "custom", key: "offer" }
              { namespace: "custom", key: "product_aesthetic_media" }
              { namespace: "custom", key: "accent_color" }
              { namespace: "custom", key: "primary_color" }
              { namespace: "custom", key: "configurator_image" }
              { namespace: "custom", key: "store_media_card_new" }
              { namespace: "custom", key: "preorder_popup" }
              { namespace: "custom", key: "configurator_image_mobile" }
            ]
          ) {
            namespace
            key
            type
            value
            reference {
              __typename
              ... on MediaImage {
                image {
                  ...image
                }
              }
              ... on Video {
                id
                previewImage {
                  url
                  width
                  height
                }
                sources {
                  url
                  mimeType
                  height
                }
              }
              ... on GenericFile {
                id
                url
                mimeType
              }
              ... on Metaobject {
                id
                type
                fields {
                  key
                  value
                }
              }
            }
            references(first: 5) {
              edges {
                node {
                  __typename
                  ... on MediaImage {
                    image {
                      ...image
                    }
                  }
                  ... on Video {
                    id
                    previewImage {
                      url
                      width
                      height
                    }
                    sources {
                      url
                      mimeType
                      height
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    featuredImage {
      ...image
    }
    images(first: 20) {
      edges {
        node {
          ...image
        }
      }
    }
    seo {
      ...seo
    }
    tags
    updatedAt
  }
  ${imageFragment}
  ${seoFragment}
`;

export default productFragment;
